// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function quoteDetails(userId, rfqId, quoteId) {
  const query = `query quoteDetails(
    $userId: ID,
    $rfqId: String
    $quoteId: String
  ) {
    quoteDetails(userId: $userId, rfqId: $rfqId, quoteId: $quoteId)  {  quote {    
      companyName
      unitPrice
      qty
      shipping
      totalCost
      unauthorized
      toolingDesc
      toolingAvailable
      sampleAvailable
      machiningReq
      ndaAccept
      status
      
      quoteDate
      comment
      deliveryDate
     
        }   
      }
    }`;

  const variables = { userId, rfqId, quoteId };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function acceptOrDenyQuote(userId, rfqId, quoteId, status) {
  const query = `mutation handleQuoteAcceptance($userId: ID, $rfqId: Int, $quoteId: Int, $status: String) { handleQuoteAcceptance (userId: $userId, rfqId: $rfqId, quoteId: $quoteId status: $status) { status msg } }`;

  const variables = { userId, rfqId, quoteId, status };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}



// WEBPACK FOOTER //
// ./src/pages/ViewQuote/graphql.js